export default __webpack_public_path__ + "static/media/amazon-color.962fa99b.svg";